module.exports = __webpack_public_path__ + "img/99.ecba1c47.jpg";